module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<header><h5 class="module-title">'+
((__t=( title ))==null?'':__t)+
'</h5></header><div><p class="error">'+
((__t=( message ))==null?'':__t)+
'</p></div>';
}
return __p;
};
